export const storeProducts = [
    {
        id:1,
        title: "Pantalon",
        img: "img/produit-1.png",
        price: 10,
        company: "PIXABAY",
        info:
        "Montius nos tumore inusitato quodam et novo ut rebellis et maiestati recalcitrantes Augustae per haec quae strepit incusat iratus nimirum quod contumacem praefectum, quid rerum ordo postulat ignorare dissimulantem formidine tenus iusserim custodiri.\n" +
            "\n" +
            "Nihil morati post haec militares avidi saepe turbarum adorti sunt Montium primum, qui divertebat in proximo, levi corpore senem atque morbosum, et hirsutis resticulis cruribus eius innexis divaricaturn sine spiramento ullo ad usque praetorium traxere praefecti.",
        inCart: false,
        count: 0,
        total:0
    },
    {
        id:2,
        title: "Montre",
        img: "img/produit-2.png",
        price: 16,
        company: "PIXABAY",
        info:
            "Montius nos tumore inusitato quodam et novo ut rebellis et maiestati recalcitrantes Augustae per haec quae strepit incusat iratus nimirum quod contumacem praefectum, quid rerum ordo postulat ignorare dissimulantem formidine tenus iusserim custodiri.\n" +
            "\n" +
            "Nihil morati post haec militares avidi saepe turbarum adorti sunt Montium primum, qui divertebat in proximo, levi corpore senem atque morbosum, et hirsutis resticulis cruribus eius innexis divaricaturn sine spiramento ullo ad usque praetorium traxere praefecti.",
        inCart: false,
        count: 0,
        total:0
    },
    {
        id:3,
        title: "Chaussure",
        img: "img/produit-3.png",
        price: 8,
        company: "PIXABAY",
        info:
            "Montius nos tumore inusitato quodam et novo ut rebellis et maiestati recalcitrantes Augustae per haec quae strepit incusat iratus nimirum quod contumacem praefectum, quid rerum ordo postulat ignorare dissimulantem formidine tenus iusserim custodiri.\n" +
            "\n" +
            "Nihil morati post haec militares avidi saepe turbarum adorti sunt Montium primum, qui divertebat in proximo, levi corpore senem atque morbosum, et hirsutis resticulis cruribus eius innexis divaricaturn sine spiramento ullo ad usque praetorium traxere praefecti.",
        inCart: false,
        count: 0,
        total:0
    },
    {
        id:4,
        title: "Robe",
        img: "img/produit-4.png",
        price: 18,
        company: "PIXABAY",
        info:
            "Montius nos tumore inusitato quodam et novo ut rebellis et maiestati recalcitrantes Augustae per haec quae strepit incusat iratus nimirum quod contumacem praefectum, quid rerum ordo postulat ignorare dissimulantem formidine tenus iusserim custodiri.\n" +
            "\n" +
            "Nihil morati post haec militares avidi saepe turbarum adorti sunt Montium primum, qui divertebat in proximo, levi corpore senem atque morbosum, et hirsutis resticulis cruribus eius innexis divaricaturn sine spiramento ullo ad usque praetorium traxere praefecti.",
        inCart: false,
        count: 0,
        total:0
    },
    {
        id:5,
        title: "Pull",
        img: "img/produit-5.png",
        price: 24,
        company: "PIXABAY",
        info:
            "Montius nos tumore inusitato quodam et novo ut rebellis et maiestati recalcitrantes Augustae per haec quae strepit incusat iratus nimirum quod contumacem praefectum, quid rerum ordo postulat ignorare dissimulantem formidine tenus iusserim custodiri.\n" +
            "\n" +
            "Nihil morati post haec militares avidi saepe turbarum adorti sunt Montium primum, qui divertebat in proximo, levi corpore senem atque morbosum, et hirsutis resticulis cruribus eius innexis divaricaturn sine spiramento ullo ad usque praetorium traxere praefecti.",
        inCart: false,
        count: 0,
        total:0
    },
    {
        id:6,
        title: "Basket",
        img: "img/produit-6.png",
        price: 17,
        company: "PIXABAY",
        info:
            "Montius nos tumore inusitato quodam et novo ut rebellis et maiestati recalcitrantes Augustae per haec quae strepit incusat iratus nimirum quod contumacem praefectum, quid rerum ordo postulat ignorare dissimulantem formidine tenus iusserim custodiri.\n" +
            "\n" +
            "Nihil morati post haec militares avidi saepe turbarum adorti sunt Montium primum, qui divertebat in proximo, levi corpore senem atque morbosum, et hirsutis resticulis cruribus eius innexis divaricaturn sine spiramento ullo ad usque praetorium traxere praefecti.",
        inCart: false,
        count: 0,
        total:0
    },
    {
        id:7,
        title: "Blazer",
        img: "img/produit-7.png",
        price: 30,
        company: "PIXABAY",
        info:
            "Montius nos tumore inusitato quodam et novo ut rebellis et maiestati recalcitrantes Augustae per haec quae strepit incusat iratus nimirum quod contumacem praefectum, quid rerum ordo postulat ignorare dissimulantem formidine tenus iusserim custodiri.\n" +
            "\n" +
            "Nihil morati post haec militares avidi saepe turbarum adorti sunt Montium primum, qui divertebat in proximo, levi corpore senem atque morbosum, et hirsutis resticulis cruribus eius innexis divaricaturn sine spiramento ullo ad usque praetorium traxere praefecti.",
        inCart: false,
        count: 0,
        total:0
    },
    {
        id:8,
        title: "T-shirt",
        img: "img/produit-8.png",
        price: 6,
        company: "PIXABAY",
        info:
            "Montius nos tumore inusitato quodam et novo ut rebellis et maiestati recalcitrantes Augustae per haec quae strepit incusat iratus nimirum quod contumacem praefectum, quid rerum ordo postulat ignorare dissimulantem formidine tenus iusserim custodiri.\n" +
            "\n" +
            "Nihil morati post haec militares avidi saepe turbarum adorti sunt Montium primum, qui divertebat in proximo, levi corpore senem atque morbosum, et hirsutis resticulis cruribus eius innexis divaricaturn sine spiramento ullo ad usque praetorium traxere praefecti.",
        inCart: false,
        count: 0,
        total:0
    },
];
export const detailProduct = {
    id:1,
    title: "Pantalon",
    img: "img/produit-1.png",
    price: 10,
    company: "PIXABAY",
    info:
        "Montius nos tumore inusitato quodam et novo ut rebellis et maiestati recalcitrantes Augustae per haec quae strepit incusat iratus nimirum quod contumacem praefectum, quid rerum ordo postulat ignorare dissimulantem formidine tenus iusserim custodiri.\n" +
        "\n" +
        "Nihil morati post haec militares avidi saepe turbarum adorti sunt Montium primum, qui divertebat in proximo, levi corpore senem atque morbosum, et hirsutis resticulis cruribus eius innexis divaricaturn sine spiramento ullo ad usque praetorium traxere praefecti.",
    inCart: false,
    count: 0,
    total:0

}




